<template>
  <d-row>
    <d-col lg="4">
      <d-card class="card-small mb-4 pt-3">

        <!-- Card Header -->
        <d-card-header class="border-bottom text-center">
          <!-- User Avatar -->
          <div class="mb-3 mx-auto">
            <upload-image :model.sync="model.settings"></upload-image>
          </div>
          <!-- User Name -->
          <h4 class="mb-0">{{ roleName }}</h4>

          <!-- User Job Title -->
          <span class="text-muted d-block mb-2">{{ model.settings.type.name }}</span>

        </d-card-header>

      </d-card>
    </d-col>
    <d-col lg="8">
      <d-card class="card-small mb-4">

        <!-- Card Header -->
        <d-card-header class="border-bottom">
          <h6 class="m-0">{{ title }}</h6>
        </d-card-header>

        <d-list-group flush>
          <d-list-group-item class="p-3">
            <d-row>
              <d-col>
                <d-form @submit.prevent="save" :validated="hasErrors">
                  <d-form-row>

                    <!-- Nome -->
                    <d-col md="6" class="form-group">
                      <label for="feFirstName">Nome</label>
                      <d-form-input type="text" id="feFirstName" placeholder="Nome" v-model="model.name" />
                    </d-col>

                    <!-- Position -->
                    <d-col md="6" class="form-group">
                      <label for="fePosition">Cargo</label>
                      <d-form-input type="text" id="fePosition" placeholder="Cargo" v-model="model.settings.position" />
                    </d-col>

                  </d-form-row>
                  <d-form-row>

                    <!-- Registration code -->
                    <d-col md="4" class="form-group">
                      <label for="feRegistrationCode">Código de registro <small>ABHO</small></label>
                      <d-form-input type="text" id="RegistrationCode" placeholder="Código de registro" v-model="model.settings.registration_code" />
                    </d-col>

                    <!-- E-mail -->
                    <d-col md="4" class="form-group">
                      <label for="feEmail">E-mail</label>
                      <d-form-input :state="hasErrorField('email')" type="email" id="feEmail" placeholder="E-mail" v-model="model.email" />
                      <d-form-invalid-feedback>E-mail é obrigatório</d-form-invalid-feedback>
                    </d-col>

                    <!-- Phone -->
                    <d-col md="4" class="form-group">
                      <label for="fePhone">Phone</label>
                      <input-phone id="fePhone" placeholder="Telefone" :model.sync="model.settings.phone"></input-phone>
                    </d-col>

                  </d-form-row>

                  <d-form-row>

                    <!-- User type -->
                    <d-col md="6" class="form-group" v-if="!isCustomer">
                      <label for="feEmail">Tipo de usuário</label>
                      <d-select v-model="model.settings.type" @change="setSettings($event, 'user_type_id')">
                        <option :value="option" v-for="(option, index) in typesList" :key="index">{{ option.name }}</option>
                      </d-select>
                    </d-col>

                    <!-- Função -->
                    <d-col md="6" class="form-group" v-if="model.settings.user_type_id !== 1 && !isCustomer">
                      <label for="feRole">Função</label>
                      <d-select v-model="model.settings.role" @change="setSettings($event, 'role_id')">
                        <option :value="option" v-for="(option, index) in rolesList" :key="index">{{ option.name }}</option>
                      </d-select>
                    </d-col>

                  </d-form-row>

                  <d-button
                    v-if="!isCustomer && model.settings.role.slug === 'cliente'"
                    class="btn-accent mb-3"
                    @click.prevent="openCustomers">
                      Adicionar clientes
                  </d-button>

                  <div class="list-group-item px-0 border-bottom-0">
                    <d-form-row>

                      <!-- Old Password -->
                      <d-col md="6" class="form-group" v-if="isCurrentUser">
                        <label for="feOldPassword">Senha antiga</label>
                        <d-form-input type="password" id="feOldPassword" placeholder="**********" v-model="model.old_password" />
                      </d-col>
                      <!-- Old Password -->
                      <d-col md="6" class="form-group" v-if="!isCurrentUser && model.id == null">
                        <!-- Generate Password -->
                        <label for="fePassword">Definir senha por e-mail</label>
                        <d-checkbox toggle :checked="sendPassword" @change="sendPassword = !sendPassword" class="custom-toggle-sm">Sim</d-checkbox>
                      </d-col>

                    </d-form-row>

                    <d-form-row>

                      <template v-if="!sendPassword || model.id || isCurrentUser">
                        <!-- Password -->
                        <d-col md="6" class="form-group">
                          <label for="fePassword">Senha</label>
                          <d-form-input :state="hasErrorField('password')" type="password" id="fePassword" placeholder="**********" v-model="model.password" />
                          <d-form-invalid-feedback>As senhas não são iguais</d-form-invalid-feedback>
                        </d-col>

                        <!-- Password -->
                        <d-col md="6" class="form-group">
                          <label for="fePasswordConfirmation">Confirmar senha</label>
                          <d-form-input :state="hasErrorField('password_confirmation')" type="password" id="fePasswordConfirmation" placeholder="**********" v-model="model.password_confirmation" />
                        </d-col>
                      </template>

                    </d-form-row>
                  </div>

                  <d-button type="submit" class="btn-accent">Salvar</d-button>

                </d-form>
              </d-col>
            </d-row>
          </d-list-group-item>
        </d-list-group>
      </d-card>
    </d-col>
    <customers-modal/>
  </d-row>

</template>

<script>
import { mapActions } from 'vuex';
import { cloneDeep } from '_utils';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import InputPhone from '_shared/InputPhone.vue';
import UploadImage from '_shared/UploadImage.vue';
import UserService from '_services/rest/modules/user';
import formatErrors from '_common/mixins/FormatErrors';
import CustomersModal from './modal/CustomersModal.vue';
import { MODEL, _LOAD_MODEL_, _SAVE_MODEL_ } from './UserModel';
import { OPTION } from '../../settings/components/SettingsModel';

export default {
  name: 'user-account-details',
  mixins: [mixin, formatErrors],
  components: {
    InputPhone,
    UploadImage,
    CustomersModal,
  },
  props: {
    title: {
      type: String,
      default: 'Perfil',
    },
    isCurrentUser: {
      type: Boolean,
      default: false,
    },
    user: {
      type: Object,
      default: null,
    },
  },
  computed: {
    rolesList() {
      const { roles } = this.$store.state.settings;
      if (roles && roles.length > 0) {
        return roles;
      }
      return [{ ...OPTION }];
    },
    typesList() {
      const { userTypes } = this.$store.state.settings;
      if (userTypes && userTypes.length > 0) {
        return userTypes;
      }
      return [{ ...OPTION }];
    },
    roleName() {
      if (this.model.settings.user_type_id === 1) {
        return 'Administrador';
      }
      if (!this.model.settings.role.name) {
        return 'Nenhum';
      }
      return this.model.settings.role.name;
    },
    isCustomer() {
      const { isCustomer } = this.$store.state.user;
      return isCustomer;
    },
  },
  data() {
    return {
      model: cloneDeep(MODEL),
      sendPassword: true,
      errors: {
        email: { required: false },
        password: { equals: false, field: 'password_confirmation' },
        password_confirmation: { equals: false, field: 'password' },
      },
    };
  },
  methods: {
    ...mapActions([
      'getRoles',
      'activeAlert',
      'setUserEdit',
      'getUserTypes',
      'saveUser',
      'setToggle',
    ]),
    getRoleId() {
      if (this.model.settings.role.id) {
        [this.model.settings.role] = this.rolesList;
      }

      return this.model.settings.role.id;
    },
    setSettings(event, field = 'role_id') {
      setTimeout(() => {
        this.model.settings.role_id = null;
        if (field === 'user_type_id' && event.id !== 1) {
          this.model.settings.role_id = this.getRoleId();
        }
        this.model.settings[field] = event.id;
        this.setUserEdit(this.model);
      }, 20);
    },
    getOptions() {
      if (!this.$store.state.settings.roles) {
        this.getRoles();
      }
      if (!this.$store.state.settings.userTypes) {
        this.getUserTypes();
      }
    },
    save() {
      if (this.checkForm()) {
        if (this.isCurrentUser) {
          return this.saveUser(this.model)
            .then(response => {
              Events.$emit(_SAVE_MODEL_, response);
              this.activeAlert({ message: response.message, theme: 'success' });
            }).catch(this.showError);
        }
        return UserService.save(this.model)
          .then(response => {
            Events.$emit(_SAVE_MODEL_, response);
            this.activeAlert({ message: response.message, theme: 'success' });
            this.$router.push(`/admin/usuarios/${response.data.id}`);
          }).catch(this.showError);
      }
      return false;
    },
    openCustomers() {
      this.setToggle({ type: 'customers_modal', bool: true });
    },
  },
  mounted() {
    if (!this.isCurrentUser) {
      this.getOptions();
    }
    Events.$on(_LOAD_MODEL_, user => {
      this.model = cloneDeep(user);
    });
  },
};
</script>
